module.exports = "/_next/static/images/82255cbd17787b812137126ddac7b26a-roxinho-details-metalico-md@2x.jpg.webp";